import { makeStyles } from '@mui/styles';
import { Colors } from '../../../../../../layout/theme-next';
import { NextTheme } from '../../../../../../layout/theme-next/provider';

export default makeStyles<NextTheme>((theme) => ({
  grid: {
    borderCollapse: 'collapse',
    '& .k-grid-content': {
      '& tr': {
        height: 38,

        '& td': {
          padding: theme.spacing(0.5, 1.5),

          '& .Mui-required.Mui-error': {
            marginTop: theme.spacing(0.25),
          },
        },
      },
    },
    '& tr.k-filter-row': {
      height: '0px !important',
    },
  },
  gridWithButton: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderBottom: 'none',
  },
  updatingRow: {
    position: 'relative',
    zIndex: 3,
    outline: `1px solid ${Colors.primaryLight}`,
    outlineOffset: -1,

    '& td': {
      verticalAlign: 'top !important',
      whiteSpace: 'normal !important' as 'normal',
    },
  },
  actions: {
    display: 'flex',
    justifyContent: 'center',
    margin: theme.spacing(0, -1.5),
  },
  activeCheckbox: {
    margin: theme.spacing(0.75, 0, 0),
  },
  inputRoot: {
    margin: theme.spacing(0, -1.125),
    width: `calc(100% + ${theme.spacing(2.25)})`,
  },
  viewIconCont: {
    display: 'flex',
    alignItems: 'center',
  },
  emptyTableMessage: {
    fontSize: 14,
    color: Colors.textDisabled,
  },
}));
